import { ApplicationNames } from './shared';
import envConfig from '../config/config';

const NEXT_PLATFORM_ROLES = ['sundial-role:T_SITE_BASE_USER'];

export const nextPlatformApplication = {
  name: ApplicationNames.NEXT_PLATFORM,
  url: envConfig.apps.nextPlatform,
  roles: NEXT_PLATFORM_ROLES,
};
